import { Typography, WithStyles, withStyles } from "@material-ui/core";
import { styles } from "../RegisterView.styles";
import React from "react";
import { CenteredContainer } from "../../components/CenteredContainer/CenteredContainer";

export interface IKneipSuccessViewProps extends WithStyles<typeof styles> {
    headline: string;
}


const KneipSuccessViewPure: React.FunctionComponent<IKneipSuccessViewProps> = ({classes, headline}) => {
    return (
        <CenteredContainer>
            <div className={classes.title}>
                <Typography variant="h2">{headline}</Typography>
            </div>
            <Typography variant="h3">Thank you.</Typography>
            <Typography variant="body1">
                Your message has been successfully sent. Kneip will contact you soon.
            </Typography>
        </CenteredContainer>
    );
};

export const KneipSuccessView = withStyles(styles)(KneipSuccessViewPure);
